export const body = {
    paddingTop: "20px"
};

export const title = {
    textAlign: "center",
    fontWeight: "bold"
};

export const itemsAccordion = {
    border: "1px solid black"
};

export const itemsRow = {
    width: "95%"
};

export const columnRight = {
    textAlign: "right"
};

export const rightPadding = {
    paddingRight: "10%"
};

export const itemsAccordion_SecondColumn = {
    textAlign: "center"
};

export const itemsAccordion_ThirdColumn = {
    textAlign: "right"
};

export const coupon_TextBox = {
    width: "50%"
};

export const hidden = {
    visibility: "hidden"
};

export const show = {
    visibility: "visible"
};

//MOBILE
export const mobile_body = {
    padding: "10px"
};
